import { NamedError } from '../utils/Errors';

export class RealTimeTranscriptionConnectionError extends NamedError<RealTimeTranscriptionConnectionErrors> {}

export enum RealTimeTranscriptionConnectionErrors {
    MicrophonePermissionError = 'MicrophonePermissionError' // User did not grant microphone permissions
}